<template>
  <div class="lang-picker-container">
    <select
      v-model="lang"
      @change="changeLanguage"
      class="lang-select"
    >
      <option v-for="code in languages" :key="code" :value="code">
        {{ code.toUpperCase() }}
      </option>
    </select>
  </div>
</template>

<script>
import i18n from '../../dashboard/i18n';

export default {
  data() {
    return {
      languages: ['en', 'sk', 'cz', 'de', 'es', 'pt', 'fr', 'pl'],
      lang: i18n.getLocale().toLowerCase()
    };
  },
  methods: {
    changeLanguage() {
      const selectedLang = this.lang.toLowerCase();
      i18n.setLocale(selectedLang);
      localStorage.setItem('lang', selectedLang);
      window.location.reload();
    }
  },
  mounted() {
    const saved = localStorage.getItem('lang');
    if (saved && this.languages.includes(saved.toLowerCase())) {
      this.lang = saved.toLowerCase();
      i18n.setLocale(this.lang);
    }
  }
};
</script>

<style scoped>
.lang-picker-container {
  display: inline-flex;
  align-items: center;
  margin: 0 10px;
}

.lang-select {
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  font-size: 13px;
  height: 32px;
  padding: 0 10px;
  border-radius: 4px;
  cursor: pointer;
  outline: none;
  transition: border-color 0.2s;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 12px;
  padding-right: 25px;
}

.lang-select:hover {
  border-color: #c0c4cc;
}

.lang-select:focus {
  border-color: #fa1f63;
}
</style>
